export default __webpack_public_path__ + "static/media/chat1.bbd6f98e.png";